<template>
  <div class="container">
    <div class="box">
      <div class="left">
        <img :src="footerObj.pic" alt="" />
        {{footerObj.title}}
      </div>
      <div class="midd">
        <h3>{{footerObj.contact_us}}</h3>
        <li>固定电话:{{footerObj.phone}}</li>
        <li>邮箱:{{footerObj.email}}</li>
        <li>联系地址:{{footerObj.address}}</li>
      </div>
      <div class="right">
        <h3>{{footerObj.business_name}}</h3>
        <li>邮箱:{{footerObj.email}}</li>
      </div>
      <div class="code">
        <img :src="footerObj.qr_code" alt="" />
        <span style="margin-top: 10px">扫码关注我们</span>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-title">广州市同航智能技术有限公司官方网站</div>
      <div>
        Copyright @ 2023-2024 广州市同航智能技术有限公司官方网站 All rights
        reserved.&nbsp;
        <a href="https://beian.miit.gov.cn" target="_blank">
          <img
            src="../../assets/beiab.png"
            style="
              width: 18px;
              height: 18px;
              vertical-align: top;
              margin-right: 5px;
            "
          />
          <span>备案编号:粤ICP备2025442824号</span></a
        >
      </div>
    </div>
  </div>
</template>

<<script>
export default {
  props:['footerObj'],
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  // position: absolute;
  //   bottom: 0;
  //   left: 0;
  // height: 250px;
  width: 100%;
  background-color: #15366c;
  .box {
    padding-top:50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .left {
      // width:100px;
      height: 70px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 100px;
        height: 100%;
      }
    }
    .midd {
      color: #fff;
      // float:left;
      text-align: left;
      li {
        margin-bottom: 20px;
        list-style: none;
        padding: 0px;
        // margin: 0px;
      }
    }
    .right {
      color: #fff;
      text-align: left;
      li {
        margin-bottom: 20px;
        list-style: none;
        padding: 0px;
        // margin: 0px;
      }
    }
    .code {
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .bottom {
    color: #fff;
    // background-color: #15366c;
    padding-top: 50px;
    padding-bottom: 50px;
    .bottom-title {
      text-align: center;
      margin-bottom: 10px;
    }
    a {
      // text-decoration: none;
      color: #fff;
    }
  }
}
</style>
